<div class="container-fluid dash-page">

  <!-- Mobile tab navigation: sticky bar, the active pill is scrolled into view (centred); the strip fades
       out at an edge while more tabs are hidden there (AppComponent: centerActiveTab / updateTabFades) -->
  <nav class="dash-tabs d-md-none">
    <div #tabStrip class="dash-tabs-strip">
      <button *ngFor="let t of navTabs" type="button"
              class="nav-tab-btn dash-tab"
              [attr.data-tab]="t.key"
              [class.active]="activeTab === t.key"
              [attr.aria-current]="activeTab === t.key ? 'page' : null"
              (click)="setTab(t.key)"><span class="dash-tab-icon" aria-hidden="true">{{ t.icon }}</span>{{ t.label | translate }}<span
              *ngIf="t.key === 'analyse' && board.items.length" class="badge rounded-pill text-bg-primary dash-tab-count">{{ board.items.length }}</span></button>
    </div>
  </nav>

  <!-- The dashboard's sections; the Analyse board (below) replaces them all, also on desktop -->
  <ng-container *ngIf="activeTab !== 'analyse'">

  <!-- ═══ ENERGIE ═══ -->
  <div id="sec-energie" *ngIf="!isMobileView || activeTab === 'energie'">
    <app-energie
      [solar]="solar"
      [solarHistory]="solarHistory"
      [solarFlash]="solarFlash"
      [liveDotOn]="liveDotOn"
      [solarUpdatedAt]="solarUpdatedAt"
      [nowTick]="nowTick"
      [todayStat]="todayStat"
      [darkMode]="darkMode"
      (openSolarChart)="openSolarChart()">
    </app-energie>
  </div>

  <!-- ═══ KLIMA ═══ -->
  <div id="sec-klima" *ngIf="!isMobileView || activeTab === 'klima'">
    <app-klima
      [thermometers]="thermometers"
      [thermometerHistory]="thermometerHistory"
      [knxFlash]="knxFlash"
      [knxUpdatedAt]="knxUpdatedAt"
      [liveDotOn]="liveDotOn"
      [nowTick]="nowTick"
      [darkMode]="darkMode"
      [adminAuth]="knxAdminAuth"
      (adminUnauthorized)="onKnxAdminUnauthorized()">
    </app-klima>
  </div>

  <!-- ═══ HEIZUNG ═══ -->
  <div id="sec-heizung" *ngIf="!isMobileView || activeTab === 'heizung'">
    <app-heizung
      [froeling]="froeling"
      [froelingHistory]="froelingHistory"
      [froelingFlash]="froelingFlash"
      [liveDotOn]="liveDotOn"
      [froelingUpdatedAt]="froelingUpdatedAt"
      [nowTick]="nowTick"
      [darkMode]="darkMode"
      [pelletStats]="pelletStats"
      [pelletUsage]="pelletUsage"
      [froelingSettings]="froelingSettings"
      (openHeizungChart)="openHeizungChart()">
    </app-heizung>
  </div>

  <!-- ═══ KNX ═══ -->
  <div id="sec-knx" *ngIf="!isMobileView || activeTab === 'knx'">
    <app-knx
      [knxDevices]="knxDevices"
      [knxDevicesUpdatedAt]="knxDevicesUpdatedAt"
      [knxDevicesFlash]="knxDevicesFlash"
      [knxWeather]="knxWeather"
      [liveDotOn]="liveDotOn"
      [nowTick]="nowTick"
      [darkMode]="darkMode">
    </app-knx>
  </div>

  <!-- ═══ ZISTERNE ═══ -->
  <div id="sec-zisterne" *ngIf="!isMobileView || activeTab === 'zisterne'">
    <app-zisterne
      [zisterne]="zisterne"
      [zisterneHistory]="zisterneHistory"
      [zisterneFlash]="zisterneFlash"
      [liveDotOn]="liveDotOn"
      [zisterneUpdatedAt]="zisterneUpdatedAt"
      [nowTick]="nowTick"
      [darkMode]="darkMode">
    </app-zisterne>
  </div>

  <!-- ═══ MÜLL ═══ -->
  <div id="sec-muell" *ngIf="!isMobileView || activeTab === 'muell'">
    <app-muell
      [nextPickupsByType]="nextPickupsByType"
      [wastePickups]="wastePickups"
      [loading]="!wasteLoaded"
      [darkMode]="darkMode">
    </app-muell>
  </div>

  <!-- ═══ STATISTIK ═══ -->
  <div id="sec-statistik" *ngIf="!isMobileView || activeTab === 'statistik'">
    <app-statistik
      [stats]="stats"
      [pelletStats]="pelletStats"
      [loading]="!statsLoaded"
      [darkMode]="darkMode">
    </app-statistik>
  </div>

  <!-- ═══ NETZWERK ═══ -->
  <div id="sec-netzwerk" *ngIf="!isMobileView || activeTab === 'netzwerk'">
    <app-netzwerk
      [unifi]="unifi"
      [unifiTimedOut]="unifiTimedOut"
      [darkMode]="darkMode">
    </app-netzwerk>
  </div>

  </ng-container>

  <!-- ═══ ANALYSE (the board: collected charts over one time window) ═══ -->
  <div id="sec-analyse" *ngIf="activeTab === 'analyse'">
    <app-board
      [thermometers]="thermometers"
      [froeling]="froeling"
      [knxWeather]="knxWeather"
      [zisterneHistory]="zisterneHistory"
      [froelingSettings]="froelingSettings"
      [darkMode]="darkMode"
      (back)="leaveBoard($event)"
      (login)="openAdmin()">
    </app-board>
  </div>

</div>

<!-- Footer: phones (< 576 px) get a slim icon-only bar; the names stay in title / aria-label -->
<footer class="dash-footer fixed-bottom bg-body-tertiary border-top">
  <span class="dash-footer-info text-muted small me-auto">
    <span class="d-none d-sm-inline">© {{ currentYear }} blonkel.com &nbsp;|&nbsp;</span><code (click)="openChangelog()" title="Changelog">{{ shortHash(frontendCommit) }}</code>
    <span class="d-none d-sm-inline">&nbsp;|&nbsp;<code (click)="openChangelog()" title="Changelog">{{ shortHash(vs.backendCommit) || '…' }}</code></span>
  </span>
  <span class="dash-footer-users text-muted small text-nowrap flex-shrink-0" [title]="'OFFENE_WEBSOCKET' | translate">
    {{ vs.connectedClients }} 👥
  </span>
  <!-- Analyse board (desktop; phones have its tab): with an admin session, or while an analyse link is open -->
  <button *ngIf="showAnalyse" type="button" class="btn btn-sm flex-shrink-0 d-none d-md-inline-flex align-items-center gap-1 ms-1"
          [ngClass]="activeTab === 'analyse' ? 'btn-secondary' : 'btn-outline-secondary'"
          [attr.aria-current]="activeTab === 'analyse' ? 'page' : null"
          (click)="setTab('analyse')">📌 {{ 'TAB_ANALYSE' | translate }}<ng-container *ngIf="board.items.length"> ({{ board.items.length }})</ng-container></button>
  <!-- Dark mode toggle -->
  <button class="btn btn-sm btn-outline-secondary flex-shrink-0 px-2 ms-1" (click)="toggleDarkMode()"
          [title]="(darkMode ? 'LIGHT_MODE' : 'DARK_MODE') | translate"
          [attr.aria-label]="(darkMode ? 'LIGHT_MODE' : 'DARK_MODE') | translate" style="line-height:1;">
    <svg *ngIf="darkMode" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
      <path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8M8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0m0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13m8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5M3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8m10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0m-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0m9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707M4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708"/>
    </svg>
    <svg *ngIf="!darkMode" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
      <path d="M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278"/>
    </svg>
  </button>
  <!-- Language switcher -->
  <button class="btn btn-sm btn-outline-secondary flex-shrink-0 px-2" (click)="openLangPicker()"
          [title]="'SPRACHE' | translate" [attr.aria-label]="'SPRACHE' | translate">
    <span class="emoji-flag" aria-hidden="true">{{ currentLangFlag }}</span>
  </button>
  <a class="btn btn-sm btn-outline-secondary flex-shrink-0 dash-footer-3d" href="/3d/" target="_blank" rel="noopener"
     [title]="'VIEW_3D' | translate" [attr.aria-label]="'VIEW_3D' | translate">
    <span class="d-none d-sm-inline" aria-hidden="true">🏠 </span>3D
  </a>
  <button class="btn btn-sm btn-outline-secondary flex-shrink-0" (click)="openApiDocs()" title="API" aria-label="API">
    🔌<span class="d-none d-sm-inline"> API</span>
  </button>
  <button class="btn btn-sm btn-outline-secondary flex-shrink-0" (click)="toggleAdmin()" title="Admin" aria-label="Admin">
    ⚙️<span class="d-none d-sm-inline"> Admin</span>
  </button>
</footer>

<!-- Admin Overlay (data-no-tv-snapshot: never part of a TV snapshot, see assets/tv-snapshot-receiver.js) -->
<!-- Phones: a full-screen sheet (styles.css: dash-overlay / dash-sheet) -->
<div *ngIf="adminOpen" data-no-tv-snapshot class="dash-overlay" style="z-index:1050;"
     (click)="closeAdmin()">

  <div class="dash-sheet dash-sheet-inset bg-body shadow-lg"
       style="width:calc(100vw - 32px);height:calc(100vh - 32px);"
       role="dialog" aria-modal="true" aria-label="Admin"
       (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="dash-sheet-head">
      <span class="dash-sheet-title">⚙️ Admin</span>
      <button *ngIf="logAuthenticated" type="button" class="btn btn-sm btn-outline-danger" (click)="adminLogout()">{{ 'ADMIN_LOGOUT' | translate }}</button>
      <app-link-button></app-link-button>
      <button class="btn btn-sm btn-outline-secondary" (click)="closeAdmin()" [attr.aria-label]="'CLOSE' | translate">✕</button>
    </div>
    <!-- Legacy admin password still accepted (ADMIN_PW_HASH unset) -->
    <div *ngIf="logAuthenticated && adminLegacyPassword"
         class="alert alert-warning rounded-0 border-0 border-bottom py-1 px-3 mb-0 small flex-shrink-0" role="alert">
      ⚠️ {{ 'ADMIN_LEGACY_PW_BANNER' | translate }}
    </div>
    <!-- No second factor configured (ADMIN_TOTP_SECRET unset): password-only login, no cameras -->
    <div *ngIf="logAuthenticated && adminTotp === false"
         class="alert alert-warning rounded-0 border-0 border-bottom py-1 px-3 mb-0 small flex-shrink-0" role="alert">
      ⚠️ {{ 'ADMIN_TOTP_MISSING_BANNER' | translate }}
    </div>

    <!-- Not authenticated: password (+ TOTP code) prompt only, no navigation hints -->
    <!-- Scrolls when the form is taller than the panel (landscape phone); my-auto centres it when it fits -->
    <div *ngIf="!logAuthenticated"
         class="flex-grow-1 d-flex justify-content-center p-4 overflow-auto" style="min-height:0;">
      <div class="my-auto" style="max-width:320px;width:100%;">
        <div *ngIf="logAuthError" class="alert alert-danger py-2 small mb-3">{{ (adminTotp === false ? 'FALSCHES_PASSWORT' : 'ADMIN_LOGIN_WRONG') | translate }}</div>
        <div *ngIf="logThrottled" class="alert alert-warning py-2 small mb-3">{{ 'ADMIN_LOGIN_THROTTLED' | translate }}</div>
        <div *ngIf="logLoginError as le" class="alert alert-warning py-2 small mb-3">{{ le.key | translate: { msg: le.msg } }}</div>
        <label class="form-label fw-semibold" for="adminPassword">{{ 'PASSWORT' | translate }}</label>
        <input id="adminPassword" type="password" class="form-control mb-3" [(ngModel)]="logPassword"
               autocomplete="current-password"
               [placeholder]="'LOGS_PASSWORT' | translate"
               (keydown.enter)="submitLogPassword()">
        <!-- Second factor (TOTP): shown unless the backend says it has no secret -->
        <ng-container *ngIf="adminTotp !== false">
          <label class="form-label fw-semibold" for="adminCode">{{ 'ADMIN_LOGIN_CODE' | translate }}</label>
          <input #adminCodeInput id="adminCode" class="form-control mb-1"
                 type="text" inputmode="numeric" pattern="\d{6}" maxlength="6" autocomplete="one-time-code"
                 autocapitalize="off" autocorrect="off" spellcheck="false" placeholder="000000"
                 style="font-family:var(--bs-font-monospace);font-size:1.25rem;letter-spacing:.3em;text-align:center;"
                 [value]="logCode" (input)="onLogCodeInput(adminCodeInput)" (keydown.enter)="submitLogPassword()">
          <div class="form-text mt-0 mb-3">{{ 'ADMIN_LOGIN_CODE_HINT' | translate }}</div>
        </ng-container>
        <button type="button" class="btn btn-primary w-100" [disabled]="logLoggingIn" (click)="submitLogPassword()">
          <span *ngIf="logLoggingIn" class="spinner-border spinner-border-sm me-1" role="status"></span>{{ 'OEFFNEN' | translate }}
        </button>
      </div>
    </div>

    <!-- Authenticated: full navigation + content -->
    <ng-container *ngIf="logAuthenticated">

      <!-- Phone section strip: the pill look of the main tab bar (styles.css: dash-tabs-strip / dash-tab),
           ≥ 40 px tall (m-touch), the pills share the width; scrolls sideways if a language needs more -->
      <nav class="d-md-none flex-shrink-0 px-2 py-2 border-bottom" [attr.aria-label]="'ADMIN_SECTIONS' | translate">
        <div class="dash-tabs-strip">
          <button *ngFor="let s of adminNav" type="button"
                  class="nav-tab-btn dash-tab m-touch flex-fill justify-content-center px-2"
                  [class.active]="adminSection === s.key"
                  [attr.aria-current]="adminSection === s.key ? 'page' : null"
                  (click)="setAdminSection(s.key)"><span class="dash-tab-icon" aria-hidden="true">{{ s.icon }}</span>{{ s.label | translate }}</button>
        </div>
      </nav>

      <!-- Body: sidebar + content -->
      <div class="d-flex flex-row flex-grow-1 overflow-hidden">

        <!-- Desktop sidebar -->
        <nav class="d-none d-md-flex flex-column border-end flex-shrink-0 py-2" style="width:160px;"
             [attr.aria-label]="'ADMIN_SECTIONS' | translate">
          <button *ngFor="let s of adminNav" type="button" class="btn btn-sm text-start px-3 py-2 rounded-0 border-0"
                  [class.fw-semibold]="adminSection === s.key"
                  [class.bg-primary-subtle]="adminSection === s.key"
                  [attr.aria-current]="adminSection === s.key ? 'page' : null"
                  (click)="setAdminSection(s.key)">
            <span aria-hidden="true">{{ s.icon }}</span> {{ s.label | translate }}
          </button>
        </nav>

        <!-- Section content -->
        <div class="flex-grow-1 overflow-hidden d-flex flex-column" [ngSwitch]="adminSection">

          <!-- ── Logs ── -->
          <ng-container *ngSwitchCase="'logs'">

            <!-- Level filter: a segmented control (full width, equal buttons on phones), ↻ at its end -->
            <div class="d-flex align-items-center gap-2 px-2 px-md-3 py-2 border-bottom flex-shrink-0">
              <div class="btn-group btn-group-sm dash-seg me-auto" role="group" [attr.aria-label]="'ADMIN_LOG_LEVEL' | translate">
                <button *ngFor="let l of logLevelBtns" type="button" class="btn"
                        [ngClass]="(logLevel === l.key ? 'btn-' : 'btn-outline-') + l.tone"
                        [attr.aria-pressed]="logLevel === l.key"
                        (click)="setLogLevel(l.key)">{{ l.label | translate }}</button>
              </div>
              <button type="button" class="btn btn-sm btn-outline-secondary flex-shrink-0 m-touch-sm" (click)="fetchLogs()"
                      [title]="'AKTUALISIEREN' | translate" [attr.aria-label]="'AKTUALISIEREN' | translate">↻</button>
            </div>

            <!-- Phones: the grid runs edge to edge (one wrapping column, see buildLogColDefs) -->
            <div class="flex-grow-1 overflow-hidden p-0 p-md-2">
              <div *ngIf="copiedCell" class="text-muted small mb-1 px-2 px-md-0">{{ 'KOPIERT' | translate }}</div>
              <div *ngIf="logs.length === 0" class="text-muted small text-center py-3">{{ 'KEINE_EINTRAEGE' | translate }}</div>
              <ag-grid-angular
                *ngIf="logs.length > 0"
                [class]="darkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'"
                style="height:100%;"
                [rowData]="logs"
                [columnDefs]="colDefs"
                [gridOptions]="gridOptions"
                [tooltipShowDelay]="200">
              </ag-grid-angular>
            </div>

          </ng-container>

          <!-- ── Clients ── -->
          <ng-container *ngSwitchCase="'clients'">

            <div class="d-flex align-items-center gap-2 px-2 px-md-3 py-2 border-bottom flex-shrink-0">
              <span class="text-muted small me-auto">{{ clients.length }} {{ 'ADMIN_VERBUNDEN' | translate }}</span>
              <button type="button" class="btn btn-sm btn-outline-secondary flex-shrink-0 m-touch-sm" (click)="fetchClients()"
                      [title]="'AKTUALISIEREN' | translate" [attr.aria-label]="'AKTUALISIEREN' | translate">↻</button>
            </div>

            <!-- Meta lines in .dash-meta (11 px); user agent and proxy headers wrap on phones (m-wrap) -->
            <div class="flex-grow-1 overflow-auto p-2 p-md-3">
              <div *ngIf="clients.length === 0" class="text-muted small text-center py-3">{{ 'ADMIN_KEINE_VERBINDUNGEN' | translate }}</div>
              <div *ngFor="let c of clients" class="card mb-2">
                <div class="card-body p-2 small">
                  <div class="d-flex flex-wrap align-items-center column-gap-2 row-gap-1 mb-1">
                    <span class="badge bg-success">🔌 {{ 'ADMIN_VERBUNDEN_BADGE' | translate }}</span>
                    <span class="fw-semibold text-break">{{ c.ip }}</span>
                    <span class="text-muted dash-meta ms-auto">{{ 'ADMIN_CLIENT_SINCE' | translate:{ time: fmtTs(c.connectedAt) } }}</span>
                  </div>
                  <div class="text-muted dash-meta text-truncate m-wrap text-break" [title]="c.userAgent">{{ c.userAgent || '–' }}</div>
                  <div class="text-muted dash-meta font-monospace text-break">
                    <div *ngIf="c.xRealIp">X-Real-IP: {{ c.xRealIp }}</div>
                    <div *ngIf="c.xForwardedFor">X-Forwarded-For: {{ c.xForwardedFor }}</div>
                    <div>remote: {{ c.remoteAddr }}</div>
                  </div>
                </div>
              </div>
            </div>

          </ng-container>

          <!-- ── KNX bus monitor (passive; polls only while shown) ── -->
          <ng-container *ngSwitchCase="'knx'">
            <app-admin-knx [authHeaders]="adminHeadersFn" (unauthorized)="onAdminUnauthorized()"></app-admin-knx>
          </ng-container>

          <!-- ── Cameras (UniFi Protect snapshots; need a login with TOTP; refresh only while shown) ── -->
          <ng-container *ngSwitchCase="'cams'">
            <app-admin-cams [authHeaders]="adminHeadersFn" (unauthorized)="onAdminUnauthorized()"
                            (legacyPassword)="adminLegacyPassword = $event"></app-admin-cams>
          </ng-container>

        </div>
      </div>

    </ng-container>
  </div>
</div>

<!-- Language Picker Overlay -->
<div *ngIf="langPickerOpen" class="dash-overlay"
     (click)="closeLangPicker()">

  <div class="dash-sheet dash-sheet-inset bg-body shadow-lg"
       style="width:min(94vw,560px);max-height:80vh;border-radius:12px;"
       role="dialog" aria-modal="true" [attr.aria-label]="'SPRACHE' | translate"
       (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="dash-sheet-head">
      <span class="dash-sheet-title">🌐 {{ 'SPRACHE' | translate }}</span>
      <button class="btn btn-sm btn-outline-secondary" (click)="closeLangPicker()" [attr.aria-label]="'CLOSE' | translate">✕</button>
    </div>

    <!-- Search -->
    <div class="px-3 py-2 border-bottom flex-shrink-0">
      <input class="form-control form-control-sm" type="search"
             [placeholder]="'SUCHEN' | translate" [(ngModel)]="langSearch" autofocus>
    </div>

    <!-- Language grid -->
    <div class="overflow-auto p-2" style="display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:6px;">
      <button *ngFor="let l of filteredLanguages"
              class="btn btn-sm text-start d-flex align-items-center gap-2 px-2 py-2"
              [class.btn-primary]="translate.currentLang === l.code"
              [class.btn-secondary]="translate.currentLang !== l.code && supportedLangs.has(l.code)"
              [class.btn-outline-secondary]="!supportedLangs.has(l.code)"
              [style.opacity]="supportedLangs.has(l.code) ? '1' : '0.4'"
              [disabled]="!supportedLangs.has(l.code)"
              (click)="selectLang(l.code)">
        <span class="emoji-flag" style="font-size:1.3rem;line-height:1;">{{ l.flag }}</span>
        <span class="min-w-0">
          <div class="fw-semibold small text-truncate" style="line-height:1.2;">{{ l.native }}</div>
          <div class="text-muted" style="font-size:.7rem;line-height:1.2;">{{ l.name }}</div>
        </span>
      </button>
    </div>

  </div>
</div>

<!-- 24h Solar Chart Overlay -->
<!-- Phones: a full-screen sheet, the range buttons in a row of their own, the chart fills the free height -->
<div *ngIf="solarChartOpen" class="dash-overlay" style="background:rgba(0,0,0,.6);"
     (click)="closeSolarChart()">
  <div class="dash-sheet bg-body shadow-lg"
       style="width:min(92vw,1600px);max-height:92vh;"
       role="dialog" aria-modal="true" [attr.aria-label]="'TAB_ENERGIE' | translate"
       (click)="$event.stopPropagation()">
    <div class="dash-sheet-head">
      <span class="dash-sheet-title flex-grow-0">📈<span class="d-sm-none"> {{ 'TAB_ENERGIE' | translate }}</span></span>
      <div class="btn-group btn-group-sm dash-seg" role="group">
        <button *ngFor="let r of chartRanges" class="btn"
                [ngClass]="chartRange === r.key ? 'btn-secondary' : 'btn-outline-secondary'"
                (click)="setChartRange(r.key, 'solar')">{{ r.label | translate }}</button>
      </div>
      <span *ngIf="rangeLoading" class="spinner-border spinner-border-sm text-muted" role="status"></span>
      <app-link-button class="ms-auto"></app-link-button>
      <button *ngIf="board.admin" type="button" class="btn btn-sm" [ngClass]="board.has('solar.all') ? 'btn-primary' : 'btn-outline-secondary'"
              [attr.aria-pressed]="board.has('solar.all')" [disabled]="!board.pinReady"
              [title]="board.pinKey('solar.all') | translate: { title: board.activeTitle }"
              [attr.aria-label]="board.pinKey('solar.all') | translate: { title: board.activeTitle }"
              (click)="board.toggle('solar.all')">📌</button>
      <button class="btn btn-sm btn-outline-secondary" (click)="closeSolarChart()" [attr.aria-label]="'CLOSE' | translate">✕</button>
    </div>
    <div class="dash-sheet-body dash-sheet-fill">
      <app-solar-chart class="dash-sheet-fill-item"
        [linkId]="chartViews.solar"
        [history]="solarChartHistory"
        [darkMode]="darkMode"
        [windowMs]="rangeWindowMs"
        [labelPv]="'CHART_ERTRAG' | translate"
        [labelBattery]="'AKKU' | translate"
        [labelGrid]="'CHART_NETZ' | translate"
        [labelTotal]="'VERBRAUCH' | translate"
        [labelSoc]="'AKKU_SOC' | translate">
      </app-solar-chart>
      <div class="text-muted text-center mt-1 dash-meta">{{ solarChartHistory.length }} {{ 'MESSPUNKTE' | translate }}</div>
    </div>
  </div>
</div>

<!-- 24h Heizung Chart Overlay -->
<div *ngIf="heizungChartOpen" class="dash-overlay" style="background:rgba(0,0,0,.6);"
     (click)="closeHeizungChart()">
  <div class="dash-sheet bg-body shadow-lg"
       style="width:min(92vw,1600px);max-height:92vh;"
       role="dialog" aria-modal="true" [attr.aria-label]="'TAB_HEIZUNG' | translate"
       (click)="$event.stopPropagation()">
    <div class="dash-sheet-head">
      <span class="dash-sheet-title flex-grow-0">🔥<span class="d-sm-none"> {{ 'TAB_HEIZUNG' | translate }}</span></span>
      <div class="btn-group btn-group-sm dash-seg" role="group">
        <button *ngFor="let r of chartRanges" class="btn"
                [ngClass]="chartRange === r.key ? 'btn-secondary' : 'btn-outline-secondary'"
                (click)="setChartRange(r.key, 'froeling')">{{ r.label | translate }}</button>
      </div>
      <span *ngIf="rangeLoading" class="spinner-border spinner-border-sm text-muted" role="status"></span>
      <app-link-button class="ms-auto"></app-link-button>
      <button *ngIf="board.admin" type="button" class="btn btn-sm" [ngClass]="board.has('froeling.all') ? 'btn-primary' : 'btn-outline-secondary'"
              [attr.aria-pressed]="board.has('froeling.all')" [disabled]="!board.pinReady"
              [title]="board.pinKey('froeling.all') | translate: { title: board.activeTitle }"
              [attr.aria-label]="board.pinKey('froeling.all') | translate: { title: board.activeTitle }"
              (click)="board.toggle('froeling.all')">📌</button>
      <button class="btn btn-sm btn-outline-secondary" (click)="closeHeizungChart()" [attr.aria-label]="'CLOSE' | translate">✕</button>
    </div>
    <div class="dash-sheet-body dash-sheet-fill">
      <app-heizung-chart class="dash-sheet-fill-item"
        [linkId]="chartViews.froeling"
        [history]="froelingChartHistory"
        [darkMode]="darkMode"
        [windowMs]="rangeWindowMs">
      </app-heizung-chart>
      <div class="text-muted text-center mt-1 dash-meta">{{ froelingChartHistory.length }} {{ 'MESSPUNKTE' | translate }}</div>
    </div>
  </div>
</div>

<!-- Initial connecting overlay (before first WS connection) -->
<div *ngIf="!vs.wsConnectedOnce && !vs.reloadPending"
     style="position:fixed;inset:0;background:var(--bs-body-bg);z-index:1060;display:flex;align-items:center;justify-content:center;">
  <div class="text-center">
    <div class="spinner-border text-primary mx-auto mb-3" role="status"></div>
    <p class="text-muted small mb-0">{{ 'VERBINDUNG_WIRD_HERGESTELLT' | translate }}</p>
  </div>
</div>

<!-- Disconnect overlay (hidden when version update overlay takes over) -->
<div *ngIf="vs.wsConnectedOnce && !vs.connected && !vs.reloadPending"
     style="position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:1060;display:flex;align-items:center;justify-content:center;">
  <div class="card text-center shadow-lg p-4" style="max-width:340px;">
    <div class="spinner-border text-danger mx-auto mb-3" role="status"></div>
    <h5 class="card-title">{{ 'VERBINDUNG_UNTERBROCHEN' | translate }}</h5>
    <p class="card-text text-muted small">{{ 'VERBINDUNG_VERLOREN' | translate }}</p>
  </div>
</div>

<!-- Changelog Overlay -->
<div *ngIf="changelogOpen" class="dash-overlay"
     (click)="closeChangelog()">
  <div class="dash-sheet bg-body shadow-lg"
       style="width:min(96vw,640px);max-height:80vh;"
       role="dialog" aria-modal="true" [attr.aria-label]="'CHANGELOG' | translate"
       (click)="$event.stopPropagation()">
    <div class="dash-sheet-head">
      <span class="dash-sheet-title">{{ 'CHANGELOG' | translate }}</span>
      <app-link-button></app-link-button>
      <button class="btn btn-sm btn-outline-secondary" (click)="closeChangelog()" [attr.aria-label]="'CLOSE' | translate">✕</button>
    </div>
    <div class="dash-sheet-body">
      <div *ngIf="changelog.length === 0" class="text-muted small text-center py-3">
        <div class="spinner-border spinner-border-sm me-2"></div>{{ 'LADE' | translate }}
      </div>
      <div *ngFor="let c of changelog" class="d-flex gap-3 py-2 border-bottom">
        <div class="flex-shrink-0 text-muted small" style="width:80px;padding-top:2px;">
          <div>{{ c.date }}</div>
          <code style="font-size:.7rem;">{{ c.hash | slice:0:7 }}</code>
        </div>
        <div class="min-w-0">
          <div class="small fw-semibold text-break">{{ c.subject }}</div>
          <div class="text-muted" style="font-size:.7rem;">{{ c.author }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- API documentation overlay -->
<div *ngIf="apiDocsOpen" class="dash-overlay"
     (click)="closeApiDocs()">
  <div class="dash-sheet bg-body shadow-lg"
       style="width:min(96vw,760px);max-height:85vh;"
       role="dialog" aria-modal="true" aria-label="API"
       (click)="$event.stopPropagation()">
    <div class="dash-sheet-head">
      <span class="dash-sheet-title">🔌 API</span>
      <a class="btn btn-sm btn-outline-secondary" href="/api/openapi.json" target="_blank" rel="noopener">openapi.json</a>
      <app-link-button></app-link-button>
      <button class="btn btn-sm btn-outline-secondary" (click)="closeApiDocs()" [attr.aria-label]="'CLOSE' | translate">✕</button>
    </div>
    <div class="dash-sheet-body">
      <p class="text-muted small">
        Read-only JSON API. The same data is also pushed live over the WebSocket
        <code>{{ location.protocol === 'https:' ? 'wss' : 'ws' }}://{{ location.host }}/ws</code>
        as <code>{{ '{' }}"type": &lt;wsType&gt;, …{{ '}' }}</code>.
        Machine-readable spec: <a href="/api/openapi.json" target="_blank" rel="noopener">/api/openapi.json</a>.
      </p>
      <p class="text-muted small">
        Every result carries its creation time: <code>/api/data/*</code> responses are wrapped in
        <code>{{ '{' }}serverTime, serverTimeIso, data{{ '}' }}</code> and every WS frame includes
        <code>serverTime</code> / <code>serverTimeIso</code> (epoch&nbsp;ms + ISO-8601, Europe/Berlin),
        so you always know how fresh the data is.
      </p>

      <div class="fw-semibold small mt-3 mb-1">{{ 'Daten' }} · <code>/api/data</code></div>
      <div *ngIf="apiResources.length === 0" class="text-muted small py-2">
        <div class="spinner-border spinner-border-sm me-2"></div>{{ 'LADE' | translate }}
      </div>
      <div class="table-responsive" *ngIf="apiResources.length">
        <table class="table table-sm align-middle dash-stack-table" style="font-size:.8rem;">
          <thead><tr><th>Endpoint</th><th>WS type</th><th>Beschreibung</th></tr></thead>
          <tbody>
            <tr *ngFor="let res of apiResources">
              <td class="text-nowrap"><a [href]="res.url" target="_blank" rel="noopener"><code>{{ res.url }}</code></a>
                  <span *ngIf="res.auth" class="badge bg-warning text-dark ms-1" [title]="'API_NEEDS_ADMIN' | translate">🔒</span></td>
              <td><code *ngIf="res.wsType">{{ res.wsType }}</code></td>
              <td>{{ res.description }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="fw-semibold small mt-3 mb-1">{{ 'Weitere Endpunkte' }}</div>
      <table class="table table-sm align-middle dash-stack-table" style="font-size:.8rem;">
        <tbody>
          <tr><td class="text-nowrap"><code>/api/data</code></td><td>Katalog aller Datenressourcen.</td></tr>
          <tr><td class="text-nowrap"><code>/api/history?series=&amp;from=&amp;to=&amp;buckets=</code></td><td>Heruntergerechnete Langzeit-Historie einer Serie.</td></tr>
          <tr><td class="text-nowrap"><code>/api/hourly?date=YYYY-MM-DD</code></td><td>Stündliche Energiedaten eines Tages.</td></tr>
          <tr><td class="text-nowrap"><code>/api/changelog</code></td><td>Letzte Git-Commits.</td></tr>
          <tr><td class="text-nowrap"><code>/api/health</code></td><td>Health-Check.</td></tr>
          <tr><td class="text-nowrap"><code>/api/openapi.json</code></td><td>Maschinenlesbare OpenAPI-3-Spezifikation.</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Version update overlay (shared with Claudia) -->
<app-version-overlay></app-version-overlay>
